import React, { useState } from "react";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AddIcon from "@mui/icons-material/Add";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

import { DefaultProps } from "model/props";
import cssLayout from "../layout.module.scss";
import css from "./calendar2screen.module.scss";
import { getLanguageString as _ } from "misc/lang";

type ValuePiece = Date | null;

type Value = ValuePiece | [ValuePiece, ValuePiece];

const Calendar2Screen: React.FC<DefaultProps> = (props) => {
  const [value, onChange] = useState<Value>(new Date());
  return (
    <div className={cssLayout.screen}>
      <div className={cssLayout.screenContent}>
        <div className={css.leftContainer}>
          <div className={css.leftContainerHeader}>
            <div className={css.calendarIconParent}>
              <CalendarMonthIcon />
            </div>
            <h3>Calendar</h3>
          </div>
          <button className={css.createNewButton}>
            <AddIcon />
            Create Event
          </button>
          <div className={css.calendarContainer}>
            <Calendar
              onChange={onChange}
              value={value}
              className={css.calendar}
            />
          </div>
        </div>
        <div className={css.rightContainer}></div>
      </div>
    </div>
  );
};

export default Calendar2Screen;
